export const safeJsonParse = (json: string | Record<string, unknown>) => {
  if (typeof json !== "string") {
    return json;
  }

  try {
    return JSON.parse(json);
  } catch (_e) {
    return json;
  }
};

/**
 * Recursively parses stringified JSON values in an object
 * @param obj - The object to parse
 * @returns The object with parsed JSON values
 */
export const parseStringifiedJson = (
  obj: string | object | Array<string | object> | null | undefined,
): object | string | Array<string | object> | null | undefined => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (typeof obj === "string") {
    // Try to parse as JSON if it looks like JSON
    if (obj.trim().startsWith("[") || obj.trim().startsWith("{")) {
      try {
        const parsed = JSON.parse(obj);
        // Recursively parse the parsed object
        return parseStringifiedJson(parsed);
      } catch {
        // If parsing fails, return the original string
        return obj;
      }
    }
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => parseStringifiedJson(item));
  }

  if (typeof obj === "object") {
    const result: Record<string, string | object | Array<string | object> | null | undefined> = {};
    for (const [key, value] of Object.entries(obj)) {
      result[key] = parseStringifiedJson(value);
    }
    return result;
  }

  return obj;
};
